import { ErrorDetails as e } from "./ErrorDetails.mjs";
import "react";
import { bustedReload as t } from "@maat/store-error";
import { useTranslation as n } from "@maat/store-i18n";
import { Button as r, Card as i, Col as a, Icons as o, Typography as s, styled as c } from "@maat/ds-core";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
//#region src/ErrorFallback/ErrorFallback.tsx
var d = c.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100vh;
    padding: ${({ theme: e }) => e.spacing(3)};
`, f = c.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 160px;
    padding: ${({ theme: e }) => e.spacing(2)};
`, p = c.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    width: 100%;
    color: ${({ theme: e }) => e.colors?.destructive ?? "#dc2626"};
`, m = c.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${({ $size: e }) => e}px;
    height: ${({ $size: e }) => e}px;
    border-radius: ${({ theme: e }) => e.radii.full};
    background: ${({ theme: e }) => e.palette?.error?.container ?? "#fde8e8"};
    color: ${({ theme: e }) => e.colors?.destructive ?? "#dc2626"};
    & > svg {
        display: block;
    }
`, h = c.div`
    width: 100%;
`, g = ({ variant: c = "section", error: g, componentStack: _, title: v, description: y, icon: b, onRetry: x, retryLabel: S, action: C, showDetails: w, children: T, className: E }) => {
	let { t: D } = n("common"), O = c === "page", k = v ?? D("states.somethingWentWrong"), A = y ?? D("errors.description"), j = C === void 0 ? x ? /* @__PURE__ */ l(r, {
		variant: "outline",
		size: "sm",
		onClick: x,
		children: S ?? D("errors.retry")
	}) : O ? /* @__PURE__ */ l(r, {
		variant: "outline",
		size: "md",
		onClick: () => t(),
		children: S ?? D("errors.reload")
	}) : null : C, M = w && g ? /* @__PURE__ */ l(h, { children: /* @__PURE__ */ l(e, {
		error: g,
		componentStack: _
	}) }) : null;
	if (c === "inline") return /* @__PURE__ */ u(p, {
		role: "alert",
		className: E,
		children: [
			b ?? /* @__PURE__ */ l(o.AlertTriangle, { size: 16 }),
			/* @__PURE__ */ l(s, {
				variant: "small",
				color: "error",
				style: { flex: 1 },
				children: k
			}),
			j
		]
	});
	let N = /* @__PURE__ */ u(a, {
		align: "center",
		gap: O ? 3 : 2,
		style: {
			textAlign: "center",
			width: "100%"
		},
		children: [
			/* @__PURE__ */ l(m, {
				$size: O ? 64 : 44,
				children: b ?? /* @__PURE__ */ l(o.AlertTriangle, { size: O ? 30 : 22 })
			}),
			/* @__PURE__ */ u(a, {
				align: "center",
				gap: 1,
				style: { width: "100%" },
				children: [/* @__PURE__ */ l(s, {
					variant: O ? "h4" : "h6",
					align: "center",
					children: k
				}), /* @__PURE__ */ l(s, {
					variant: O ? "body" : "small",
					color: "secondary",
					align: "center",
					children: A
				})]
			}),
			T,
			j,
			M
		]
	});
	return O ? /* @__PURE__ */ l(d, {
		role: "alert",
		className: E,
		children: /* @__PURE__ */ l(i, {
			glass: !0,
			padding: "large",
			radius: "xl",
			elevation: "medium",
			style: {
				maxWidth: 440,
				width: "100%"
			},
			children: N
		})
	}) : /* @__PURE__ */ l(f, {
		className: E,
		children: /* @__PURE__ */ l(i, {
			bordered: !0,
			padding: "medium",
			radius: "lg",
			elevation: "none",
			style: {
				maxWidth: 420,
				width: "100%"
			},
			children: N
		})
	});
};
//#endregion
export { g as ErrorFallback };
